module.exports = __webpack_public_path__ + "static/media/by.522a8a43.svg";